export type Language = {
  code: string;
  locale: string;
  label: string;
};

export const languages: Language[] = [
  { code: 'en', locale: 'en-US', label: 'English' },
  { code: 'el', locale: 'el-GR', label: 'Ελληνικά' },
  { code: 'de', locale: 'de-DE', label: 'Deutsch' },
  { code: 'fr', locale: 'fr-FR', label: 'Français' },
  { code: 'ru', locale: 'ru-RU', label: 'Русский' },
];
